import { render, staticRenderFns } from "./processedTab.vue?vue&type=template&id=edd4bc94&"
import script from "./processedTab.vue?vue&type=script&lang=js&"
export * from "./processedTab.vue?vue&type=script&lang=js&"
import style0 from "./processedTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports